// extracted by mini-css-extract-plugin
module.exports = {"carCardWrapper":"_3Rg03","carLogoWrapper":"_1sPDZ","carLogo":"_35O4w"};